module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-text-Quote-JJ-name.aeea6d4.png";